import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
// import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import { connect } from 'react-redux';

// const styles = {
//   font: {
//     fontStyle: 'ITALIC',
//   },
// };

class AuthorizationPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,    
    };
  }

  // handleOnRequestChange = (e,value) => {
  //   let authorizationViewTitle = 'Total View';
    
  //   if(value === 'Total View')
  //   {
  //     authorizationViewTitle = "Total View";
  //   } 
  //   else if(value === 'Monthly View')
  //   {
  //     authorizationViewTitle = "Monthly View";
  //   }
  //   else if(value === 'Weekly View')
  //   {
  //     authorizationViewTitle = "Weekly View";
  //   }
    
  //   //this.props.handleChangeAuthorization(authorizationViewTitle);
  // }

  render(){
    const panelClass = classNames ({
        'readmin-panel' : true,
        'righticonmenu': true,
        'body-text-center': this.props.center
    });

    return (
        <div className={panelClass}>
        <div className="panel-mainheading">
          <h5>Authorization Utilization Chart</h5>
        </div>
        <div className="panel-heading panel-heading-withsubtitle">
            {/* <h5>{this.props.authorizationViewTitle}</h5> */}
          { this.props.righticon ? 
            <IconMenu
              //{...props}
              iconButtonElement={
              <IconButton><i className="material-icons">more_vert</i></IconButton>
              }
              targetOrigin={{horizontal: 'right', vertical: 'top'}}
              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            >
              {/* <MenuItem primaryText="Total View" onClick={(e) => this.handleOnRequestChange(e,'Total View')}/>
              <MenuItem primaryText="Monthly View" onClick={(e) => this.handleOnRequestChange(e,'Monthly View')}/>
              <MenuItem primaryText="Weekly View" onClick={(e) => this.handleOnRequestChange(e,'Weekly View')}/>               */}
            </IconMenu>
          : null}
        </div>
        <div className="panel-body">
          {this.props.children}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        loginUserInfo: state.login.loginUserInfo, 
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    };
};

export default connect(mapStateToProps, { })(AuthorizationPanel);


// WEBPACK FOOTER //
// ./src/adminCharts/AuthorizationPanelToolTip.js